// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eg-0";